<div class="select">
    @if(showLabel) {
        <div>{{label}}</div>
    }
    <div class="c-dropdown" [class.disabled]="disabled" [class.show]="displayMenu" [class.error]="error"  (mouseleave)="closeMenu()">
        <div class="c-dropdown-toggle" (click)="disabled ? null : toggleMenu()">
            @if(iconSrc) {
                <div class="image-container">
                    <img [src]="iconSrc">
                </div>
            }
            <div class="select-label">
                <span [class.select-placeholder]="!selectedOption && showPlaceholder">{{selectedOption ? selectedOption : (showPlaceholder ? placeholder : '')}}</span>
            </div>
            <div class="arrow-container">
                <img src="assets/icons/select-arrow.svg">
            </div>
        </div>

        @if(displayMenu) {
            <!-- Fill the gap between the dropdown and dropdown menu so mouseleave event will not trigger in-between the two elements. -->
            <div class="extension"></div>
        }
       
        @if(displayMenu && options.length > 0) {
            <div class="c-dropdown-menu">
                <div class="dropdown-menu-section">
                    @for(option of options; track $index;) {
                        <div (click)="selectOption(option)" class="dropdown-menu-option" [class.disabled]="option.disabled">
                            {{option.label}}</div>
                    }
                </div>
            </div>
        }
    </div>
</div>